import React, { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Benefits from './components/Benefits';
import WhatIsHector from './components/WhatIsHector';
import WhyPartnerships from './components/WhyPartnerships';
import WhoCanJoin from './components/WhoCanJoin';
import CommissionValue from './components/CommissionValue';
import Objections from './components/Objections';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import CommissionStick from './components/CommissionStick';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import PopupModal from './components/pop';

function App() {
      const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    // Log app initialization
    console.log('🚀 Hector Affiliate Program loaded successfully!');
    console.log('💼 Ready to transform your Amazon expertise into revenue.');
    
    // Track page performance
    if ('performance' in window) {
      window.addEventListener('load', () => {
        setTimeout(() => {
          const perfData = window.performance.timing;
          const pageLoadTime = perfData.loadEventEnd - perfData.navigationStart;
          console.log('Page Load Time:', pageLoadTime + 'ms');
        }, 0);
      });
    }
  }, []);

  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <Benefits />
        <WhatIsHector />
        <WhyPartnerships />
        <WhoCanJoin />
        <CommissionValue />
        <Objections />
        <Features />
        <HowItWorks />
        <CommissionStick />
        <Testimonials />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <ScrollToTop />
      <PopupModal show={isPopupOpen} onClose={() => setIsPopupOpen(false)} />

    </div>
  );
}

export default App;
